module.exports = __webpack_public_path__ + "static/img/8.489ed1d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/8.gif
// module id = KuPk
// module chunks = 1